'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var slicedToArray = require('../../node_modules/@babel/runtime/helpers/slicedToArray.js');
var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var Typography = require('../../DesignSystem/DataDisplay/Typography/Typography.js');
var ObjectHelper = require('../../common/ObjectHelper.js');
var classNames = require('classnames');
var makeStyles = require('../../DesignSystem/Styles/makeStyles.js');
var useTheme = require('../../DesignSystem/Styles/useTheme.js');
var FormHelperText = require('../../node_modules/@material-ui/core/esm/FormHelperText/FormHelperText.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var cardElementStyle = function cardElementStyle(theme) {
  return {
    base: {
      fontSize: '15px',
      color: theme.palette.text.primary,
      fontFamily: theme.typography.fontFamily,
      '::placeholder': {
        color: theme.palette.text.secondary
      },
      ':focus': {
        '::placeholder': {
          color: 'rgba(0, 0, 0, 0)'
        }
      }
    },
    invalid: {
      color: '#F50057'
    }
  };
};

var useStyles = makeStyles["default"](function (theme) {
  return {
    backgroundFilled: {
      boxSizing: 'border-box',
      backgroundColor: theme.palette.grey[100],
      height: 55,
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
      padding: '7px 10px 0px 12px',
      marginBottom: -6,
      borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
      '&:hover': {
        borderBottom: '1px solid rgba(0, 0, 0, 0.87)'
      }
    },
    cardNumberLabelFilled: {
      fontSize: 12,
      color: 'rgba(0, 0, 0, 0.54)',
      paddingBottom: 3
    },
    cardNumberLabelFocused: {
      color: 'rgb(23, 105, 170)'
    },
    cardNumberLabelError: {
      color: theme.palette.error.main
    },
    inputBottomBorderStyle: {
      marginTop: 6,
      width: '100%',
      position: 'relative',
      boxSizing: 'content-box'
    },
    greyBorderFilled: {
      width: '100%',
      position: 'absolute',
      height: 1,
      backgroundClip: 'padding-box'
    },
    focusBorder: {
      width: '100%',
      position: 'absolute',
      transform: 'scaleX(0)',
      transition: 'transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
      borderBottom: '1px solid rgb(33, 150, 243)'
    },
    focusBorderActive: {
      transform: 'scaleX(1)'
    },
    errorBorder: {
      width: '100%',
      position: 'absolute',
      height: 2,
      backgroundColor: theme.palette.error.main,
      top: -1
    },
    errorText: {
      margin: '12px 14px 0',
      color: theme.palette.error.main
    }
  };
});

var InputBottomBorder = function InputBottomBorder(_ref) {
  var errorMessage = _ref.errorMessage,
      focused = _ref.focused;

  var _useStyles = useStyles(),
      greyBorderFilled = _useStyles.greyBorderFilled,
      focusBorder = _useStyles.focusBorder,
      inputBottomBorderStyle = _useStyles.inputBottomBorderStyle,
      focusBorderActive = _useStyles.focusBorderActive,
      errorBorder = _useStyles.errorBorder;

  var focusBorderClass = classNames__default["default"](focusBorder, defineProperty({}, "".concat(focusBorderActive), focused));
  return React__default["default"].createElement("div", {
    className: inputBottomBorderStyle
  }, React__default["default"].createElement("div", {
    className: greyBorderFilled
  }), React__default["default"].createElement("div", {
    className: ObjectHelper.isPresent(errorMessage) ? errorBorder : focusBorderClass
  }));
};

var withStripeStyle = function withStripeStyle() {
  return function (WrappedComponent) {
    var WrappedStripeElementComponent = function WrappedStripeElementComponent(props) {
      var _useStyles2 = useStyles(),
          cardNumberLabelFilled = _useStyles2.cardNumberLabelFilled,
          cardNumberLabelError = _useStyles2.cardNumberLabelError,
          cardNumberLabelFocused = _useStyles2.cardNumberLabelFocused,
          backgroundFilled = _useStyles2.backgroundFilled,
          errorText = _useStyles2.errorText;

      var theme = useTheme();

      var _useState = React.useState(false),
          _useState2 = slicedToArray(_useState, 2),
          focused = _useState2[0],
          setFocused = _useState2[1];

      var className = classNames__default["default"](cardNumberLabelFilled, defineProperty({}, "".concat(cardNumberLabelFocused), focused), defineProperty({}, "".concat(cardNumberLabelError), props.errorMessage));
      return React__default["default"].createElement("div", null, React__default["default"].createElement("div", {
        className: backgroundFilled
      }, React__default["default"].createElement(Typography, {
        type: "caption",
        className: className
      }, props.labelName), React__default["default"].createElement(WrappedComponent, {
        onChange: props.onChange,
        onFocus: function onFocus() {
          return setFocused(true);
        },
        onBlur: function onBlur() {
          return setFocused(false);
        },
        placeholder: props.placeholder,
        value: props.value,
        cardElementStyle: cardElementStyle(theme)
      })), React__default["default"].createElement(InputBottomBorder, {
        errorMessage: props.errorMessage,
        focused: focused
      }), ObjectHelper.isPresent(props.errorMessage) && React__default["default"].createElement(FormHelperText["default"], {
        error: true,
        className: errorText
      }, props.errorMessage));
    };

    return WrappedStripeElementComponent;
  };
};

exports.useStyles = useStyles;
exports.withStripeStyle = withStripeStyle;
